define('drops/dateInput/dateInputNative',[
    'jquery',
    'underscore',
    'lq/style'
], function ($, _, Style) {
    'use strict';

    function DateInputNative(drop) {
        this.drop = drop;

        var self = this;
        this.$dateInput = $('<input>')
            .attr('type', this.drop.data.showTimePicker ? "datetime-local" : "date")
            .css({
                width: '100%',
                height: '100%',
                display: 'inline-block',
                whiteSpace: 'normal'
            })
            .attr('id', drop.rootDrop.instanceId + '_' + drop.data.id)
            .addClass('date-picker')
            .attr('tabindex', this.drop.data.tabIndex)
            .attr('placeholder', this.drop.data.watermark)
            .addClass('boxToBorderSize')
            .attr("min", this.drop.data.minDate)
            .attr("max", this.drop.data.maxDate)
            .on("blur", function () {
                drop.triggerEventIfEnabled('focusLost');
            })
            .on("change", function () {
                var selectedDate = new Date(this.value);
                self.drop.updateDate(selectedDate);
            })
            .appendTo(this.drop.$element);

        if (this.drop.data.readOnly)
            this.$dateInput.prop('inert', true);

        this.$dateInput.css({
            border: 'none',
            font: 'inherit'
        });

        if (drop.data.fitContent) {
            this.$dateInput.css({
                fieldSizing: 'content',
                width: ''
            });
        }
    }

    DateInputNative.prototype.initialize = $.noop;

    DateInputNative.prototype.afterDateUpdatedSuccesfully = $.noop;

    DateInputNative.prototype.focus = function () {
        this.$dateInput.trigger('focus');
    };

    DateInputNative.prototype.clearValue = function () {
        this.$dateInput.val(null);
    };

    DateInputNative.prototype.setValue = function (newDate) {
        var localTimeAsString = new Date(newDate.getTime() - newDate.getTimezoneOffset() * 60 * 1000).toISOString();
        var value = this.drop.data.showTimePicker
            ? localTimeAsString.substr(0, 19)
            : localTimeAsString.substr(0, 10);
        this.$dateInput.val(value);
    };

    DateInputNative.prototype.unsubscribeEventHandlers = $.noop;

    return DateInputNative;
});

